import { gql } from 'graphql-tag';

import AffiliationCardBlockFragment from '@fragments/shared/AffiliationCardBlockFragment';
import ButtonBlockFragment from '@fragments/shared/ButtonBlockFragment';
import ContentCardBlockFragment from '@fragments/shared/ContentCardBlockFragment';
import ContentFeedBlockFragment from '@fragments/shared/ContentFeedBlockFragment';
import EventPanelBlockFragment from '@fragments/shared/EventPanelBlockFragment';
import GalleryBlockFragment from '@fragments/shared/GalleryBlockFragment';
import HeadingBlockFragment from '@fragments/shared/HeadingBlockFragment';
import HtmlBlockFragment from '@fragments/shared/HtmlBlockFragment';
import ImageBlockFragment from '@fragments/shared/ImageBlockFragment';
import PersonBlockFragment from '@fragments/shared/PersonBlockFragment';
import PullQuoteBlockFragment from '@fragments/shared/PullQuoteBlockFragment';
import RichTextBlockFragment from '@fragments/shared/RichTextBlockFragment';
import SubscribeBlockFragment from '@fragments/shared/SubscribeBlockFragment';
import TagFeedBlockFragment from '@fragments/shared/TagFeedBlockFragment';
import VideoBlockFragment from '@fragments/shared/VideoBlockFragment';

export default gql`
    fragment StreamTierW333333Fragment on W33_33_33 {
        columnLayout
        w33_33_33___colorScheme: colorScheme
        w33_33_33___topPadding: topPadding
        w33_33_33___bottomPadding: bottomPadding
        w33_33_33___alignment: alignment
        blocks {
            ...AffiliationCardBlockFragment
            ...ButtonBlockFragment
            ...ContentCardBlockFragment
            ...ContentFeedBlockFragment
            ...EventPanelBlockFragment
            ...GalleryBlockFragment
            ...HeadingBlockFragment
            ...HtmlBlockFragment
            ...ImageBlockFragment
            ...PersonBlockFragment
            ...PullQuoteBlockFragment
            ...RichTextBlockFragment
            ...SubscribeBlockFragment
            ...TagFeedBlockFragment
            ...VideoBlockFragment
        }
        blockName
        blockType
    }
    ${AffiliationCardBlockFragment}
    ${ButtonBlockFragment}
    ${ContentCardBlockFragment}
    ${ContentFeedBlockFragment}
    ${EventPanelBlockFragment}
    ${GalleryBlockFragment}
    ${HeadingBlockFragment}
    ${HtmlBlockFragment}
    ${ImageBlockFragment}
    ${PersonBlockFragment}
    ${PullQuoteBlockFragment}
    ${RichTextBlockFragment}
    ${SubscribeBlockFragment}
    ${TagFeedBlockFragment}
    ${VideoBlockFragment}
`;
